import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=d2739640&"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts&"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=d2739640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports